export const STEP_OPTION = {
  Feel: "Feel",
  Plan: "Plan",
  Do: "Do",
  Time: "Time",
  Close: "Close",
  Review: "Review"
};

export const SIZESANDSTYLES = {
  small: "100%",
  medium: "200%",
  large: "250%",
  italics: "italics",
  bold: "bold"
}

export const TIMEFRAME = {
  Day: "Day",
  Week: "Week",
  Month: "Month",
  Season: "Season",
  Year: "Year",
  Life: "Life",
  All: "All"
}
export let timeframeOptions = [
  TIMEFRAME.Day,
  TIMEFRAME.Week,
  TIMEFRAME.Month,
  TIMEFRAME.Season,
  TIMEFRAME.Year,
  TIMEFRAME.Life,
  TIMEFRAME.All
]
export let stepOptions = [
  STEP_OPTION.Feel,
  STEP_OPTION.Plan,
  STEP_OPTION.Do,
  STEP_OPTION.Time,
  STEP_OPTION.Close,
  STEP_OPTION.Review
];

export const STATUS_OPTION_HEX_PALLETE = {
  blue: "#147bd1",
  green: "#2dc84d",
  white: "white",
  yellow: "#f7ea48",
  red: "#e03c31",
  purple: "#753bbd",
  black: "black"
};
export const APP_BACKGROUND_COLOR = "#c1c1c1";
export const NAV_BACKGROUND_COLOR = "#b2b2b2";
export const BUCKETLIST_CONTAINER_BACKGROUND_COLOR = "#e0e0e0";
export const LUCKET_DETAILS_BACKGROUND_COLOR = "#F0F0F0";
export const SESSION_TRACKER_BACKGROUND_COLOR = "#d3d3d3";
export let statusOptionsPalletes = [
  STATUS_OPTION_HEX_PALLETE.Blue,
  STATUS_OPTION_HEX_PALLETE.Green,
  STATUS_OPTION_HEX_PALLETE.White,
  STATUS_OPTION_HEX_PALLETE.Yellow,
  STATUS_OPTION_HEX_PALLETE.Red,
  STATUS_OPTION_HEX_PALLETE.Purple,
  STATUS_OPTION_HEX_PALLETE.Black
];

export const STATUS_OPTION = {
  Blue: "blue",
  Green: "green",
  White: "white",
  Yellow: "yellow",
  Red: "red",
  Purple: "purple",
  Black: "black"
};

export let statusOptions = [
  STATUS_OPTION.Blue,
  STATUS_OPTION.Green,
  STATUS_OPTION.White,
  STATUS_OPTION.Yellow,
  STATUS_OPTION.Red,
  STATUS_OPTION.Purple,
  STATUS_OPTION.Black
];
export const CLOSE_OPTIONS = {
  StartFresh: "Start Fresh",
  CarryOver: "Carry Over"
};
export const closeOptions = [
  CLOSE_OPTIONS.StartFresh,
  CLOSE_OPTIONS.CarryOver
];


export const LUCKET_COLOR_RANK = { purple: 3, blue: 2, green: 1, white: 0, yellow: -1, red: -2, black: -3 };

export const CATEGORIES = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
export const TimeOptions = ['LN', 'DN', 'EM', 'MO', 'NO', 'AF', 'EV', 'NI'];

export const TimeOptionsLabel = ['Late Night', 'Dawn', 'Early Morning', 'Morning', 'Noon', 'Afternoon', 'Evening', 'Night'];

